import { render } from "./WorkloadRecommendingDialog.vue?vue&type=template&id=6c444bf2"
import script from "./WorkloadRecommendingDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadRecommendingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__